import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ButtonBase from '@mui/material/ButtonBase';

// project imports
import DrawerHeaderStyled from './DrawerHeaderStyled';
import terrainImg from '/terrain.png';
import { APP_DEFAULT_PATH } from 'config';

// ==============================|| DRAWER HEADER ||============================== //

export default function DrawerHeader({ open }) {
  return (
    <DrawerHeaderStyled
      open={open}
      sx={{
        minHeight: '60px',
        width: 'initial',
        paddingTop: '8px',
        paddingBottom: '8px',
        paddingLeft: open ? '24px' : 0
      }}
    >
      <ButtonBase disableRipple component={Link} to={APP_DEFAULT_PATH} aria-label="Logo">
        <img src={terrainImg} alt="terrain" style={{ width: open ? 'auto' : 35, height: 35 }} />
      </ButtonBase>
    </DrawerHeaderStyled>
  );
}

DrawerHeader.propTypes = { open: PropTypes.bool };
